<app-header [menuList$]="menuList$" [memberInfo$]="memberInfo$"></app-header>

<div id="main-visual" class="carousel slide" data-ride="carousel" data-interval="5000">
  <!-- Indicators -->
  <ul class="carousel-indicators carousel-indicators-change">
    <li class="active" data-target="#main-visual" data-slide-to="0"></li>
    <li class="" data-target="#main-visual" data-slide-to="1"></li>
    <li class="" data-target="#main-visual" data-slide-to="2"></li>
  </ul>

  <div class="carousel-inner">
    <div class="carousel-item active">
      <a routerLink="/ahri" [queryParams]="{menu_seq: 432}" style="display:inline-block;width:100%;height:100%;">
        <img src="/assets/images/main_banner01.jpg" alt="main visual">
      </a>

      <div class="main-txt">
        <div><img src="/assets/images/kraia.png" alt="KRAIA" /></div>
        <div class="txt">냉난방공조기기 제조업체 공동의<br/>이익증진과 발전을 위해 노력합니다</div>
        <div class="main-btn-outer">
          <div class="main-btn-background"></div>
          <a routerLink="/ahri" [queryParams]="{menu_seq:432}" class="main-btn">AHRI 국내인증업체 확인</a>
        </div>
      </div>
    </div>

    <div class="carousel-item">
      <img src="/assets/images/main_banner02.jpg" alt="main visual">

      <div class="main-txt">
        <div><img src="/assets/images/kraia.png" alt="KRAIA" /></div>
        <div class="txt">냉난방공조기기 제조업체 공동의<br/>이익증진과 발전을 위해 노력합니다</div>
      </div>
    </div>

    <div class="carousel-item">
      <img src="/assets/images/main_banner03.jpg" alt="main visual">

      <div class="main-txt">
        <div><img src="/assets/images/kraia.png" alt="KRAIA" /></div>
        <div class="txt">냉난방공조기기 제조업체 공동의<br/>이익증진과 발전을 위해 노력합니다</div>
      </div>
    </div>
  </div>

  <!-- Left and right controls -->
  <a class="carousel-control-prev" href="#main-visual" data-slide="prev">
    <span class="carousel-control-prev-icon"></span>
  </a>
  <a id="carousel-control-next" class="carousel-control-next" href="#main-visual" data-slide="next">
    <span class="carousel-control-next-icon"></span>
  </a>

  <div class="quick-menu">
    <ul>
      <li><a routerLink="/member/list"><span class="icon"></span><span class="title el">회원사정보</span></a></li>
      <li><a routerLink="/information/bidding"><span class="icon"></span><span class="title el">입찰정보</span></a></li>
      <li><a routerLink="/contents" [queryParams]="{menu_seq:184}"><span class="icon"></span><span class="title el">인증사업</span></a></li>
      <li><a routerLink="/contents" [queryParams]="{menu_seq:220}"><span class="icon"></span><span class="title el">자문서비스</span></a></li>
      <li><a routerLink="/contents" [queryParams]="{menu_seq:152}"><span class="icon"></span><span class="title el">프리미엄서비스</span></a></li>
      <li><a routerLink="/board/list" [queryParams]="{board_id:'ecatalogs'}"><span class="icon"></span><span class="title el">e카달로그</span></a></li>
    </ul>
  </div>
</div>

<div class="cb"></div>

<div class="information-center main-wrap">
  <h2 class="section-title">정보센터</h2>
  <ul class="information-link">
    <li [ngClass]="{active: information_active == '1'}" (click)="information_active='1';">
      <a routerLink="/">공지사항</a>
      <a routerLink="/board/list" [queryParams]="{board_id:'notice'}" class="more-link">더보기</a>
      <!-- 모바일에서 보임 -->
      <div class="information-list card-list mobile-1000">
        <ul>
          <ng-container *ngFor='let item of boardData[0];let i = index'>
          <li *ngIf="i < 7">
            <a routerLink="/board/view" [queryParams]="{board_id:'notice',board_seq:item.board_seq}">
              <p class="kind">공지사항</p>
              <p class="title el">{{item.subject}}<p>
              <p class="date">{{item.write_date}}</p>
            </a>
          </li>
          </ng-container>
          <li class="more">
            <a routerLink="/board/list" [queryParams]="{board_id:'notice'}">
              <p class="icon-more"></p>
              <p class="more-txt">더보기</p>
            </a>
          </li>
        </ul>
        <div class="cb"></div>
      </div>
    </li>
    <li [ngClass]="{active: information_active == '2'}" (click)="information_active='2';">
      <a routerLink="/">정책·홍보</a>
      <a routerLink="/board/list" [queryParams]="{board_id:'kraiasns'}" class="more-link">더보기</a>
      <!-- 모바일에서 보임 -->
      <div class="information-list card-list mobile-1000">
        <ul>
          <ng-container *ngFor='let item of boardData[1];let i = index'>
          <li *ngIf="i < 7">
            <a routerLink="/board/view" [queryParams]="{board_id: 'kraiasns',board_seq: item.board_seq}">
              <p class="kind">정책·홍보</p>
              <p class="title el">{{item.subject}}<p>
              <p class="date">{{item.write_date}}</p>
            </a>
          </li>
          </ng-container>
          <li class="more">
            <a routerLink="/board/list" [queryParams]="{board_id:'kraiasns'}">
              <p class="icon-more"></p>
              <p class="more-txt">더보기</p>
            </a>
          </li>
        </ul>
        <div class="cb"></div>
      </div>
    </li>
    <li [ngClass]="{active: information_active == '3'}" (click)="information_active='3';">
      <a routerLink="/">냉난방공조 뉴스</a>
      <a routerLink="/board/list" [queryParams]="{board_id:'airConditioning_news'}" class="more-link">더보기</a>
      <!-- 모바일에서 보임 -->
      <div class="information-list card-list mobile-1000">
        <ul>
          <ng-container *ngFor='let item of boardData[2];let i = index'>
          <li *ngIf="i < 7">
            <a routerLink="/board/view" [queryParams]="{board_id: 'news',board_seq: item.board_seq}">
              <p class="kind">냉난방공조 뉴스</p>
              <p class="title el">{{item.subject}}<p>
              <p class="date">{{item.write_date}}</p>
            </a>
          </li>
          </ng-container>
          <li class="more">
            <a routerLink="/board/list" [queryParams]="{board_id:'news'}">
              <p class="icon-more"></p>
              <p class="more-txt">더보기</p>
            </a>
          </li>
        </ul>
        <div class="cb"></div>
      </div>
    </li>
    <li [ngClass]="{active: information_active == '4'}" (click)="information_active='4';">
      <a routerLink="/">환경ㆍ에너지</a>
      <a routerLink="/board/list" [queryParams]="{board_id:'foreignnews'}" class="more-link">더보기</a>
      <!-- 모바일에서 보임 -->
      <div class="information-list card-list mobile-1000">
        <ul>
          <ng-container *ngFor='let item of boardData[3];let i = index'>
          <li *ngIf="i < 7">
            <a routerLink="/board/view" [queryParams]="{board_id: 'foreignnews',board_seq: item.board_seq}">
              <p class="kind">환경ㆍ에너지</p>
              <p class="title el">{{item.subject}}<p>
              <p class="date">{{item.write_date}}</p>
            </a>
          </li>
          </ng-container>
          <li class="more">
            <a routerLink="/board/list" [queryParams]="{board_id:'foreignnews'}">
              <p class="icon-more"></p>
              <p class="more-txt">더보기</p>
            </a>
          </li>
        </ul>
        <div class="cb"></div>
      </div>
    </li>
  </ul>

  <!-- pc에서 보임 -->
  <div class="information-list card-list pc-1000" *ngIf="information_active == '1'">
    <swiper [config]="SwiperConfigInterface_notice">
      <ul *ngFor="let key of checkLastPage(0)">
        <ng-container *ngFor='let item of boardData[0];let i = index'>
        <li *ngIf="checkLi(i, key)">
          <a routerLink="/board/view" [queryParams]="{board_id:'notice',board_seq:item.board_seq}">
            <p class="kind">공지사항</p>
            <p class="title el">{{item.subject}}<p>
            <p class="date">{{item.write_date}}</p>
          </a>
        </li>
        </ng-container>
        <li *ngIf="key == getLastPage(0)" class="more">
          <a routerLink="/board/list" [queryParams]="{board_id:'notice'}">
            <p class="icon-more"></p>
            <p class="more-txt">더보기</p>
          </a>
        </li>
      </ul>
    </swiper>
    <div class="cb"></div>
  </div>
  <div class="information-list card-list pc-1000" *ngIf="information_active == '2'">
    <swiper [config]="SwiperConfigInterface_notice">
      <ul *ngFor="let key of checkLastPage(1)">
        <ng-container *ngFor='let item of boardData[1];let i = index'>
        <li *ngIf="checkLi(i, key)">
          <a routerLink="/board/view" [queryParams]="{board_id: 'kraiasns',board_seq: item.board_seq}">
            <p class="kind">정책·홍보</p>
            <p class="title el">{{item.subject}}<p>
            <p class="date">{{item.write_date}}</p>
          </a>
        </li>
        </ng-container>
        <li *ngIf="key == getLastPage(1)" class="more">
          <a routerLink="/board/list" [queryParams]="{board_id:'kraiasns'}">
            <p class="icon-more"></p>
            <p class="more-txt">더보기</p>
          </a>
        </li>
      </ul>
    </swiper>
    <div class="cb"></div>
  </div>
  <div class="information-list card-list pc-1000" *ngIf="information_active == '3'">
    <swiper [config]="SwiperConfigInterface_notice">
      <ul *ngFor="let key of checkLastPage(2)">
        <ng-container *ngFor='let item of boardData[2];let i = index'>
        <li *ngIf="checkLi(i, key)">
          <a routerLink="/board/view" [queryParams]="{board_id: 'news',board_seq: item.board_seq}">
            <p class="kind">냉난방공조 뉴스</p>
            <p class="title el">{{item.subject}}<p>
            <p class="date">{{item.write_date}}</p>
          </a>
        </li>
        </ng-container>
        <li *ngIf="key == getLastPage(2)" class="more">
          <a routerLink="/board/list" [queryParams]="{board_id:'news'}">
            <p class="icon-more"></p>
            <p class="more-txt">더보기</p>
          </a>
        </li>
      </ul>
    </swiper>
    <div class="cb"></div>
  </div>
  <div class="information-list card-list pc-1000" *ngIf="information_active == '4'">
    <swiper [config]="SwiperConfigInterface_notice">
      <ul *ngFor="let key of checkLastPage(3)">
        <ng-container *ngFor='let item of boardData[3];let i = index'>
        <li *ngIf="checkLi(i, key)">
          <a routerLink="/board/view" [queryParams]="{board_id: 'foreignnews',board_seq: item.board_seq}">
            <p class="kind">환경ㆍ에너지</p>
            <p class="title el">{{item.subject}}<p>
            <p class="date">{{item.write_date}}</p>
          </a>
        </li>
        </ng-container>
        <li *ngIf="key == getLastPage(3)" class="more">
          <a routerLink="/board/list" [queryParams]="{board_id:'foreignnews'}">
            <p class="icon-more"></p>
            <p class="more-txt">더보기</p>
          </a>
        </li>
      </ul>
    </swiper>
    <div class="cb"></div>
  </div>
  <div class="cb"></div>
</div>

<div class="cb"></div>

<div class="banner main-wrap">
  <ul>
    <li>
      <a routerLink="/member/list">
        <p class="title el">회원사 현황</p>
        <p class="txt">한국냉동공조산업협회 회원사를 소개합니다.</p>
      </a>
    </li>
    <li>
      <a routerLink="/contents" [queryParams]="{menu_seq: 230}">
        <p class="title el">해외전시회</p>
        <p class="txt">해외전시회 스케줄을 알려드립니다.</p>
      </a>
    </li>
    <li>
      <a routerLink="/contents" [queryParams]="{menu_seq: 184}">
        <p class="title el">인증사업</p>
        <p class="txt">AHRI 인증 프로그램을 소개합니다.</p>
      </a>
    </li>
    <li>
      <a href="http://www.harfko.com/" target="_blank">
        <p class="title el">HARFKO</p>
        <p class="txt">냉난방공조분야 최고의 축제 한국국제냉난방공조전</p>
      </a>
    </li>
  </ul>
</div>

<div class="cb"></div>

<div class="member-company main-wrap">
  <h2 class="section-title">회원사 소식</h2>
  <div class="member-calendar">
    <div class="title el">
      <p>이달의<br class="pc-only">회원사<br class="pc-only">일<span class="pc-only">&nbsp;&nbsp;&nbsp;&nbsp;</span>정</p>
      <p class="mon"><span>{{month}}</span>월</p>
    </div>
    <div class="calendar">
      <ul>
        <ng-container *ngIf="boardData[5].length > 0">
        <li *ngFor="let item of boardData[5]">
          <a routerLink="/board/view" [queryParams]="{board_id: 'companymonth',board_seq: item.board_seq}">
            <span>{{item.schedule_date}}일</span>{{item.subject}}
          </a>
        </li>
        </ng-container>
        <ng-container *ngIf="boardData[5].length < 0">
        <li>등록된 회원사 일정이 없습니다.</li>
        </ng-container>
      </ul>
    </div>
  </div>

  <div class="cb"></div>
  <span class="card-name">회원사정보</span>
  <a routerLink="/board/list" [queryParams]="{board_id:'member_news'}" class="more-link">더보기</a>
  <!-- pc에서 보임 -->
  <div class="member-notice card-list pc-1000">
    <swiper [config]="SwiperConfigInterface_notice">
      <ul *ngFor="let key of checkLastPage(4)">
        <ng-container *ngFor='let item of boardData[4];let i = index'>
        <li *ngIf="checkLi(i, key)">
          <a routerLink="/board/view" [queryParams]="{board_id: 'companynews',board_seq: item.board_seq}">
            <p class="kind">회원사정보</p>
            <p class="title el">{{item.subject}}<p>
            <p class="date">{{item.write_date}}</p>
          </a>
        </li>
        </ng-container>
        <li *ngIf="key == getLastPage(4)" class="more">
          <a routerLink="/board/list" [queryParams]="{board_id:'companynews'}">
            <p class="icon-more"></p>
            <p class="more-txt">더보기</p>
          </a>
        </li>
      </ul>
    </swiper>
    <div class="cb"></div>
  </div>

  <!-- 모바일에서 보임 -->
  <div class="member-notice card-list mobile-1000">
    <ul>
      <ng-container *ngFor='let item of boardData[4];let i = index'>
      <li *ngIf="i < 7">
        <a routerLink="/board/view" [queryParams]="{board_id: 'companynews',board_seq: item.board_seq}">
          <p class="kind">회원사정보</p>
          <p class="title el">{{item.subject}}<p>
          <p class="date">{{item.write_date}}</p>
        </a>
      </li>
      </ng-container>
      <li class="more">
        <a routerLink="/board/list" [queryParams]="{board_id:'companynews'}">
          <p class="icon-more"></p>
          <p class="more-txt">더보기</p>
        </a>
      </li>
    </ul>
    <div class="cb"></div>
  </div>
</div>

<div class="cb"></div>

<div class="link-area">
  <div class="main-wrap">
    <h2 class="section-title">바로가기</h2>

    <div class="slide-wrap">
      <swiper [config]="SwiperConfigInterface_link" class="link-list">

        <ng-container *ngFor="let row of bannerBottomList; let i = index">
          <div>
            <a href="{{row.link}}" target="_blank">
              <p class="img"><img src="{{row.url}}" alt="{{row.title}}"></p>
              <p class="name">{{row.title}}</p>
            </a>
          </div>
        </ng-container>

      </swiper>
      <div  class="swiper-pagination"></div>
      <div class="swiper-button-next1"></div>
      <div class="swiper-button-prev1"></div>
    </div>
  </div>
</div>

<div class="cb"></div>

<div class="link-area1">
  <div class="main-wrap">
    <h2 class="section-title sr-only">바로가기</h2>

    <div class="link-list1">
      <ul>
        <li [ngClass]="{on: link_list == '1'}">
          <p class="kind" (click)="onLink(1);">관련단체</p>
          <ul>
            <li><a href="http://www.kmcca.or.kr" target="_blank">대한기계설비건설협회</a></li>
            <li><a href="http://www.sarek.or.kr" target="_blank">대한설비공학회</a></li>
            <li><a href="http://www.karse.or.kr" target="_blank">한국설비기술협회</a></li>
            <li><a href="http://www.kbiz.or.kr" target="_blank">중소기업중앙회</a></li>
            <li><a href="http://www.koami.or.kr" target="_blank">한국기계산업진흥회</a></li>
            <li><a href="http://www.kscia.or.kr" target="_blank">한국정밀화학산업진흥회</a></li>
            <li><a href="http://www.kaca.or.kr" target="_blank">한국공기청정협회</a></li>
            <li><a href="http://www.kraac.or.kr" target="_blank">한국냉동공조인증센터</a></li>
          </ul>
          <div class="cb"></div>
        </li>
        <li [ngClass]="{on: link_list == '2'}">
          <p class="kind" (click)="onLink(2);">연구원</p>
          <ul>
            <li><a href="http://www.kitech.re.kr" target="_blank">한국생산기술연구원</a></li>
            <li><a href="http://www.ktl.re.kr" target="_blank">한국산업기술시험원</a></li>
            <li><a href="http://www.kimm.re.kr" target="_blank">한국기계연구원</a></li>
            <li><a href="http://www.kist.re.kr" target="_blank"> 한국과학기술연구원 공조환경제어연구팀</a></li>
          </ul>
          <div class="cb"></div>
        </li>
        <li [ngClass]="{on: link_list == '3'}">
          <p class="kind" (click)="onLink(3);">교육기관</p>
          <ul>
            <li><a href="http://www.korea.ac.kr" target="_blank">고려대학교냉동 및 공기조화연구실</a></li>
            <li><a href="http://www.kookmin.ac.kr" target="_blank">국민대학교 공기조화 냉동공학연구실</a></li>
            <li><a href="http://www.pknu.ac.kr" target="_blank">부경대학교 냉동공조학과, 에너지 시스템 연구실</a></li>
            <li><a href="http://www.snu.ac.kr" target="_blank">서울대학교 공기조화 냉동공학 실험실</a></li>
            <li><a href="http://www.inha.ac.kr" target="_blank">인하대학교 GFC 대체시스템연구실</a></li>
            <li><a href="http://www.postech.ac.kr" target="_blank">포항공과대학교 환경 열유체 연구실</a></li>
            <li><a href="http://www.kmaritime.ac.kr" target="_blank">한국해양대학교 냉동공조학 전공</a></li>
            <li><a href="http://www.hanyang.ac.kr" target="_blank">한양대 건축설비 환경공학연구실,HVAC/CFD연구실</a></li>
          </ul>
          <div class="cb"></div>
        </li>
        <li [ngClass]="{on: link_list == '4'}">
          <p class="kind" (click)="onLink(4);">정부투자기관</p>
          <ul>
            <li><a href="http://www.kgs.or.kr" target="_blank">한국가스안전공사</a></li>
            <li><a href="http://www.kogas.or.kr" target="_blank">한국가스공사</a></li>
          </ul>
          <div class="cb"></div>
        </li>
        <li [ngClass]="{on: link_list == '5'}">
          <p class="kind" (click)="onLink(5);">해외사이트</p>
          <ul>
            <li><a href="http://www.ashrae.org" target="_blank">ASHRAE</a></li>
            <li><a href="http://www.heatpumpcentre.org" target="_blank">IEA Heat Pump Centre</a></li>
            <li><a href="http://www.bsria.co.uk" target="_blank">BSRIA UK</a></li>
            <li><a href="http://www.iifiir.org" target="_blank">IIR (국제냉동기구)</a></li>
            <li><a href="http://www.jraia.or.jp" target="_blank">일본냉동공조협회</a></li>
            <li><a href="http://www.chinacraa.org" target="_blank">중국제냉동공조협회</a></li>
            <li><a href="http://www.ahrinet.org" target="_blank">미국냉동공조협회</a></li>
            <li><a href="http://www.ejarn.com" target="_blank">JARN</a></li>
            <li><a href="http://www.ahrinet.org/" target="_blank">AHRI</a></li>
          </ul>
          <div class="cb"></div>
        </li>
      </ul>
      <div class="cb"></div>
    </div>
  </div>

  <div class="cb"></div>
</div>

<!-- 팝업 //-->
<section *ngFor="let row of popupList">
  <div *ngIf="getPopupToday(row.board_seq)">
    <div class="popup-layer" [ngStyle]="{'width':row.popup_width+'px', 'height':((row.popup_height*1)+50)+'px', 'left':row.screen_x+'px', 'top':row.screen_y+'px'}" [ngClass]="{hidden: row.is_popup_preview == false, 'popup-layer-mobile':isMobile===true}">
      <div class="popup-preview-contents" [innerHTML]="row.contents"></div>

      <!-- 오늘 더 이상 열지 않기 처리 //-->
      <div class="popup-button-area">
        <div class="fl">
          <label class="popup-not-today">
            <input type="checkbox" name="checkBtn" (click)="setPopupToday(row)" /> 오늘 더 이상 보지 않음
          </label>
        </div>
        <div class="fr">
          <button type="button" class="btn btn-default" (click)="row.is_popup_preview=false">창닫기</button>
        </div>
        <div class="cb"></div>
      </div>
    </div>
  </div>
</section>

<app-footer></app-footer>
